var $sliders = [];

function setSliderStatus(el){
	var status = el.data('flickity'),
		limit = status.cells.length;
	el.removeClass('is-start').removeClass('is-end');
	if(status.selectedIndex == 0){
		el.addClass('is-start');
	} else if(status.selectedIndex == limit - 1){
		el.addClass('is-end');
	}
}

$(function(){
	$('.slider-project').each(function(i){
		var scope = $(this),
			items = scope.find('.slider-project-item');

		$sliders[i] = $(this).flickity({
			pageDots:false,
			cellAlign:'left',
			prevNextButtons:false,
			contain:true,
			freeScroll:true,
			wrapAround:false,
			draggable:true,
			imagesLoaded:false
		}),
		$prev = $('<button>',{class:'slider-prev'}),
		$next = $('<button>',{class:'slider-next'});

		setSliderStatus($sliders[i]);

		$(this).find('img,video').bind('load',function(){
			$sliders[i].flickity('resize');
		})
		
		// Buttons
		$prev.click(function(){
			$sliders[i].flickity('previous');
			setSliderStatus($sliders[i])
		}).appendTo(scope);
		$next.click(function(){
			$sliders[i].flickity('next');
			setSliderStatus($sliders[i])
		}).appendTo(scope);

		// CURSOR
		scope.find('.flickity-viewport').hover(function(){
		  $cursor.addClass('hover swipe');
		},function(){
		  $cursor.removeClass('hover swipe');
		});
		$prev.hover(function(){
		  $cursor.addClass('hover prev');
		},function(){
		  $cursor.removeClass('hover prev');
		});
		$next.hover(function(){
		  $cursor.addClass('hover next');
		},function(){
		  $cursor.removeClass('hover next');
		});
	})
});